import { render, staticRenderFns } from "./addAbsenceSg.vue?vue&type=template&id=8af30036&"
import script from "./addAbsenceSg.vue?vue&type=script&lang=js&"
export * from "./addAbsenceSg.vue?vue&type=script&lang=js&"
import style0 from "./addAbsenceSg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports